import Game from '../../Game';
import BaseUISystem from './BaseUISystem';
import QuitMenuHandler from './Menu/QuitMenuHandler';
import BoosterHUDHandler from './HUD/BoosterHUDHandler';
import ThreeStarShareHandler from './Menu/ThreeStarShareHandler';
import HelperFriendHUDHandler from './HUD/HelperFriendHUDHandler';
import { HelperFriendStatus } from '../../State/Level/HelperFriend/HelperFriendStatus';
import InfoMenuHandler from './Menu/InfoMenuHandler';
import { ShopPopup } from './Menu/ShopPopup/ShopPopup';
import NoCoinsMenuHandler from './NotImplemented/NoCoinsMenuHandler';
import StreakInfoPopup from '../../Prototype/UI/Level/StreakInfoPopup';
import { LevelPopup } from './Menu/LevelPopup/LevelPopup';
import { BuyBoosterPopup } from './Menu/LevelPopup/BuyBoosterPopup';
import { LevelCompletePopup } from './Menu/LevelPopup/LevelCompletePopup';
import DataConflictsMenuHandler from 'System/UI/Menu/DataConflictsMenuHandler';
import ConfirmSignOutMenuHandler from 'System/UI/Menu/ConfirmSignOutMenuHandler';
import { isNative, Platform } from 'Utility/Platform';
import HardSharePopup from './Menu/LevelPopup/HardSharePopup';
import { LevelHud } from 'System/UI/HUD/LevelHud';
import { SettingsPopup } from "@platform/System/UI/Menu/SettingsPopup";

export default class LevelUISystem extends BaseUISystem {
    public init(): void {
        const levelHud = new LevelHud({ system: this });

        this.handlers = [
            new BoosterHUDHandler(this),
            new SettingsPopup(this),
            new QuitMenuHandler(this),
            new ThreeStarShareHandler(this),
            new HardSharePopup(this),
            new InfoMenuHandler(this),
            new NoCoinsMenuHandler(this),
            new ShopPopup(this),
            new StreakInfoPopup(this),
            new LevelPopup(this),
            new LevelCompletePopup(this),
            new BuyBoosterPopup(this),
            levelHud,
            new DataConflictsMenuHandler(this),
            new ConfirmSignOutMenuHandler(this),
        ];

        if (Game.store.getState().platform.IAPSupport) {
            //this.handlers.push(new ShopPopup(this));
        }

        if (
            (isNative()) &&
            Game.store.getState().levelState.helperFriendStatus === HelperFriendStatus.ENABLED
        ) {
            this.handlers.push(new HelperFriendHUDHandler(this));
        }
    }
}
